<template>
  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>
        title
      </v-toolbar>

      <v-card-text class="mt-4">
        <p>{{form.ticketNumber}} от {{form.ticketDate}}</p>
        <form>

          <v-text-field
              label="Локация"
              prepend-icon="mdi-map-marker-outline"
              v-model="form.ticketLocation"
              readonly
          ></v-text-field>

          <v-text-field
              label="Статус"
              prepend-icon="mdi-text-box-search"
              v-model="form.ticketStatus"
              readonly
          ></v-text-field>

          <v-textarea
              label="Комментарий"
              v-model="form.comment"
              prepend-icon="mdi-comment-outline"
              readonly
          ></v-textarea>





          <v-btn text color="primary" @click="downloadFile(file)" v-for="file in form.files" :key="file.fileGUID">
            <v-icon dark>
              mdi-download
            </v-icon>
            {{file.fileName}}</v-btn>


        </form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Negative" text>{{ $t('common.button_close') }}</v-btn>


<!--        <v-btn @click="Positive" color="primary">{{ $t('common.button_ok') }}</v-btn>-->
      </v-card-actions>
    </v-card>
  </popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal";
import { mapActions } from "vuex"
// eslint-disable-next-line
import {downloadBase64File, fileToBase64, selectFile} from "@/domain/utils";

export default {
  name: "DialogEditTicket",
  components: { PopupModal },
  data: () => ({

    inputData: {title:""},

    form: {
      ticketNumber: "",
      ticketDate: "",
      ticketLocation: "",
      ticketStatus: "",
      files: [],
      // fileGUID: "",
      // fileMetatype: "",
      comment: "",
    },



    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    ...mapActions("app", ["apiGetFile"]),

    async downloadFile(file){
      console.log('downloadFile')
      await this.apiGetFile({fileGUID: file.fileGUID, fileMetatype: file.fileMetatype})
    },

    show(opts = {}) {
      console.log(opts)
      this.form = opts
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true);

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    Positive() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "positive", form: this.form });
    },
    Negative() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "negative" });
    },
  },
  computed:{

  },
};
</script>
